import { get, post, put, deleteApi, postForm } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";
import {
  writeDataToLocalStorage,
  readDataFromLocalStorage,
  triggerStripeJSCall,
} from "../../utils/globalUtils";

const { APIS } = API_ENDPOINTS;

/*
==========================================
        Profile Settings Services
==========================================
*/

export const getProfileInfoService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.USERPROFILE}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const uploadProfilePictureService = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.USERS}/picture`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAccountSettingsService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.ORGS}/settings`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAccountInfoService = data =>
  new Promise((resolve, reject) => {
    put(`${APIS.ORGS}/settings/info`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAccountPictureService = data =>
  new Promise((resolve, reject) => {
    console.debug(data);
    postForm(`${APIS.ORGS}/logo`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAccountEmailService = data =>
  new Promise((resolve, reject) => {
    put(`${APIS.ORGS}/settings/email`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const addAccountAddressService = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.ORGS}/address`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deleteAccountAddressService = id =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.ORGS}/address/${id}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAccountAddressService = (id, data) =>
  new Promise((resolve, reject) => {
    put(`${APIS.ORGS}/address/${id}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

/*
==========================================
        Authentication Settings Services
==========================================
*/

export const getSAMLSettingsService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.SAML_SETTINGS}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateSAMLSettingsService = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.SAML_SETTINGS}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const uploadSAMLCertificateService = data =>
  new Promise((resolve, reject) => {
    postForm(`${APIS.UPLOAD_SAML_CERTIFICATE}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

/*
==========================================
        Billing Settings Services
==========================================
*/

export const getBillingInfo = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.BILLING_INFO}`)
      .then(response => {
        // Temp logic to prevent spam in snaplink & magic link
        writeDataToLocalStorage(
          "revv_planStatus",
          response &&
            response.billing_details &&
            response.billing_details.subscription &&
            response.billing_details.subscription.status,
        );
        resolve(response && response.billing_details);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getChargeBeeCheckoutUrl = planName =>
  new Promise((resolve, reject) => {
    get(`${APIS.CHARGEBEE_CHECKOUT_URL}/${planName}`)
      .then(response => {
        resolve(response && response.checkout_url);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getChargeBeePaymentUrl = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.CHARGEBEE_PAYMENT_URL}`)
      .then(response => {
        resolve(response && response.payment_url);
      })
      .catch(error => {
        reject(error);
      });
  });

export const transactionCheckout = (docID, success_url, cancel_url, price_id) =>
  new Promise((resolve, reject) => {
    post(`${APIS.STRIPE_TRANSACTION_CHECKOUT}/${docID}`, {
      success_url,
      cancel_url,
      price_id,
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const subscriptionCheckout = payload =>
  new Promise((resolve, reject) => {
    const userInfo = readDataFromLocalStorage("revvsalesUser");
    post(`${APIS.STRIPE_BILLING_CHECKOUT}`, {
      name: `${userInfo.first_name} ${userInfo.last_name}`,
      user_email: userInfo.user_email,
      price_id: payload,
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const stripePortalURL = () =>
  new Promise((resolve, reject) => {
    const userInfo = readDataFromLocalStorage("revvsalesUser");
    post(`${APIS.STRIPE_BILLING_PORTAL}`, {
      name: `${userInfo.first_name} ${userInfo.last_name}`,
      user_email: userInfo.user_email,
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const stripeLastPayment = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.STRIPE_BILLING_PAYMENT}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const checkPaymentRequired = docID =>
  new Promise((resolve, reject) => {
    get(`${APIS.DOCS}/${docID}/payment-detail`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const invokeStripe = () =>
  new Promise((resolve, reject) =>
    // stripe promise
    triggerStripeJSCall()
      .then(() =>
        resolve(
          window.Stripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`),
        ),
      )
      .catch(err => {
        reject();
        console.error("settingsService.js => invokeStripe =>", err);
      }),
  );

/*
==========================================
     Revv Oauth  Settings Services
==========================================
*/

export const getRevvOauthAppsService = () =>
  new Promise((resolve, reject) =>
    get(`${APIS.REVV_OAUTH}`)
      .then(response => {
        resolve((response && response) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );

export const createRevvOauthAppService = appName =>
  new Promise((resolve, reject) =>
    post(`${APIS.REVV_OAUTH}`, appName)
      .then(response => {
        resolve((response && response.Application) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );

export const createRevvOauthClientService = (appID, url) =>
  new Promise((resolve, reject) =>
    post(`${APIS.REVV_OAUTH}${appID}/clients/`, url)
      .then(response => {
        resolve((response && response.Client) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );

export const updateRevvOauthAppService = (appID, data) =>
  new Promise((resolve, reject) =>
    put(`${APIS.REVV_OAUTH}${appID}`, data)
      .then(response => {
        resolve((response && response) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );

export const updateRevvOauthClientService = (clientID, url) =>
  new Promise((resolve, reject) =>
    put(`${APIS.REVV_OAUTH_CLIENT}${clientID}`, url)
      .then(response => {
        resolve((response && response.Client) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );

export const deleteRevvOauthClientService = clientID =>
  new Promise((resolve, reject) =>
    deleteApi(`${APIS.REVV_OAUTH_CLIENT}${clientID}`)
      .then(response => {
        resolve((response && response.Application) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );

export const deleteRevvOauthClientSecretService = clientID =>
  new Promise((resolve, reject) =>
    deleteApi(`${APIS.CLIENT_CREDENTIALS}/${clientID}`)
      .then(response => {
        resolve((response && response.Application) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );

export const updateEsignSettings = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.SIGNATURE_SETTING}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const extendEsignExpiryForDoc = (docID, data) =>
  new Promise((resolve, reject) => {
    put(`${APIS.SIGNATURE_SETTING}/docs/${docID}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const removeEsignSettingsFlag = flag =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.SIGNATURE_SETTING}/${flag}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

/*
==========================================
    Email prefernces Settings Services
==========================================
*/

export const getEmailPreferencesService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.EMAIL_PREFERENCES}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const saveEmailPreferencesService = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.EMAIL_PREFERENCES}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateSecretKeyService = appId =>
  new Promise((resolve, reject) => {
    post(`${APIS.APPLICATIONS}/secret/${appId}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const generateClientCredentialService = appId =>
  new Promise((resolve, reject) => {
    get(`${APIS.APPLICATIONS}/${appId}/client-credentials/`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
